import React from 'react'

import moment from 'moment'

import {inWords, removeZeros} from '../../../utils/misc'
import {getUserSettings} from '../../../storage'
import HistoryChoser from '../historyChoser'

const TableCustomPadding = () =>(
  <style>
{".preview-a4, p {font-family: 'Times New Roman', Times;} .preview-a4 .table>tbody>tr>td { padding: 8px;} table.fullwidth {width: 100%;margin-top: 5px;}table.fullwidth .pad {padding-left: 5px!important;}"
}
  </style>
)

export default class RetailA   extends React.Component {

  render() {


        let company = this.props.company
        let invoice = this.props.invoice
        let historyRecords = this.props.history
        let settings = this.props.settings || getUserSettings()
        let brandRow = <small><i>Generated with https://www.goodsbill.com</i></small>
        let invoice_date = moment(invoice.date).format('D-MM-YYYY')
        let billto_1, billto_2, billFrom
        let place_of_supply
        let shipping_address
        let optionalRow = false
        let table_cols = 6
        let invoice_label = "INVOICE"
        let show_mrp_column = false
        let show_container_unit = false
        let serial = invoice.series_name + invoice.series_counter
        let bankDetails, declartion, tnc

        let options, historySelection


        if(typeof settings !== "undefined" && settings !== null) {

          if(settings) {
            options = settings.options
          }
          if(options && options.show_invoice_history) {
            historySelection = <HistoryChoser handleHistorySelect={this.props.handleHistorySelect} records ={historyRecords} />
          }

           if(settings.invoice_label) {
             invoice_label = <div className="invoice-name" style={{fontFamily:'serif'}}>
                <span>{settings.invoice_label}</span>
             </div>
           }

           if(settings.show_invoice_tnc) {

           tnc = <div><u>Terms and Conditions</u>
                 <div><p>{settings.invoice_tnc}</p></div>
                 </div>
           }

           if(settings.show_invoice_declaration) {

           declartion = <div><u>Declaration</u>
                 <div><p>{settings.invoice_declaration}</p></div>
                 </div>
           }

           if(settings.show_invoice_bankdetails) {

             bankDetails = <div><div className="row">
                   <div className="col-xs-12 space-small-bottom"><strong >Bank Details</strong></div>
                 <div className="col-xs-6">Bank Name</div>
                 <div className="col-xs-6">{company.bank_name}</div>
                 </div>
                 <div className="row">
                   <div className="col-xs-6">Account No</div>
                   <div className="col-xs-6">{company.account_no}</div>
                 </div>
                 <div className="row">
                   <div className="col-xs-6">IFSC</div>
                   <div className="col-xs-6">{company.ifsc_code}</div>
                 </div>
                 <div className="row">
                   <div className="col-xs-6">Branch </div>
                   <div className="col-xs-6">{company.branch_name}</div>
                 </div>

                 </div>
           }
        }

        let company_gstin, company_phone, company_name, company_address, company_additional_params

        if(typeof company.gstin !== "undefined" && company.gstin.length > 0) {
          company_gstin = <span>{"GSTIN: " +company.gstin}</span>
        }
        if(company.additional_params && company.additional_params.length) {
          let additional_params_list = company.additional_params.map(function(param, i) {
            return <li key={i}><span className="gray">{param.key} {param.value}</span></li>
          })
          company_additional_params= <ul className="list-inline" style={{marginBottom:0}}>{additional_params_list}</ul>
        }

        if(typeof company.phone !== "undefined" && company.phone.length > 0) {
          company_phone = <span >{"Ph: " +company.phone}</span>
        }
        if(typeof company.company_name !== "undefined" && company.company_name.length > 0) {
          company_name = <div className="company-name text-uppercase" style={{fontSize:26, fontWeight:400, fontFamily:"serif"}}>

                          {company.company_name}
                        </div>
        }
        company_address = <div className="space-small-bottom"> {company.address} {company.city} {company.state}({company.state_code}) {company.pin}</div>






        if(typeof invoice.client !== "undefined" && invoice.client !== null) {
          place_of_supply = invoice.client.city
          let client_gstin
          let client_phone
          if(typeof invoice.client.gstin !== "undefined" && invoice.client.gstin !== null && invoice.client.gstin.length > 0) {
            client_gstin = "GSTIN-"+invoice.client.gstin
          }
          if(typeof invoice.client.phone !== "undefined" && invoice.client.phone !== null && invoice.client.phone.length > 0) {
            client_phone = "Ph: " + invoice.client.phone
          }
          if(!invoice.client.same_as_biiling) {
            shipping_address = <div>  <div className="gray">
                    <strong>{invoice.client.name}</strong>
              </div>
              <div className="gray">
                  {invoice.client.shipping_address}
              </div>
              <div className="gray">
              <span className="gray">
              {invoice.client.shipping_city}
              </span>
              <span className="gray">
              {" "+invoice.client.shipping_state} {" "+invoice.client.shipping_pin}
              </span>
              <span className="gray">
              {invoice.client.shipping_state_code.length > 0 ? " State Code: "+invoice.client.shipping_state_code: ""}
              </span>

              </div>
              <div className="gray">
                  {invoice.client.shipping_state}-{invoice.client.shipping_pin}
              </div></div>
          }
          else {
            shipping_address = <div>  <div className="gray">
                    <strong>{invoice.client.name}</strong>
              </div>
              <div className="gray">
                  {invoice.client.address}
              </div>
              <div className="gray">
                <span className="gray">
                {invoice.client.city}
                </span>
                <span className="gray">
                {" "+invoice.client.state} {" "+invoice.client.pin}
                </span>
              <span className="gray">
              {invoice.client.state_code.length > 0 ? " State Code: "+invoice.client.state_code: ""}
              </span>

              </div>
              </div>
          }

          billto_1 =  <div className="row"><div className="col-xs-12">
            <div className="">
            <strong>Bill To</strong>
              <div className="gray">
                  <strong>{invoice.client.name}</strong>
              </div>
              <div className="gray">
                  {invoice.client.address}
              </div>
              <div>
                <span className="gray">
               {invoice.client.city} {" "+invoice.client.state}
                </span>
                <span className="gray">
                {" "+invoice.client.pin}
                </span>
                <span className="gray">
                {invoice.client.state_code.length > 0 ? " State Code: "+invoice.client.state_code: ""}
                </span>
              </div>
              <div>
              </div>
              <div className="gray">
                 {client_gstin}
              </div>
            </div>
          </div></div>

          billto_2 = <div className="row"><div className="col-xs-12">
            <div className="">
            <strong>Ship To</strong>
              {shipping_address}
            </div>
            <div>
              {client_phone}
            </div>
          </div></div>




        }
        // end of billto

        let items, summaryRow
        if(invoice.saleitem_set.length > 0) {

          invoice.saleitem_set.sort((a,b)=>{
            return a.tableIndex - b.tableIndex
          })

          items = invoice.saleitem_set.map((saleitem, index)=>{
            let discountCol, cgstcol, sgstcol, igstcol
            let unit_price = Number(saleitem.selling_rate),
            taxable_price = parseFloat(saleitem.price).toFixed(2),
            item_total = parseFloat(saleitem.total).toFixed(2)

            let mrp_column
            if(show_mrp_column) {
              mrp_column = <td className="text-right">{parseFloat(saleitem.mrp).toFixed(2)}</td>
            }

            if(saleitem.discount_percent) {
              discountCol = <td className="text-right">{removeZeros(saleitem.discount_percent)} %</td>
            }
            else if(saleitem.discount_value > 0) {
                discountCol = <td className="text-right">{removeZeros(saleitem.discount_value)}</td>
            }
            else {
              discountCol = <td className="text-right"></td>
            }


            return <tr key={index}>
              <td><div>{saleitem.name}</div></td>
              <td className="text-right">{parseFloat(saleitem.mrp).toFixed(2)}</td>
              <td className="text-right">{unit_price}</td>
              <td className="text-right">
                <div>{Number(saleitem.quantity)}</div>
              </td>

              <td className="text-right">{item_total}</td>
          </tr>
          })
        }


        let summaryRowSpan = 3

        let summaryQuantity=0, summaryDiscount=0, summaryTaxable=0, summaryIGST=0, summaryCGST=0, summarySGST=0, summaryTotal=0, summaryRate=0, summarySaved=0
        let percentages={cgst:{}, sgst:{}, igst:{}}
        for (var i = 0; i < invoice.saleitem_set.length; i++) {
            const si = invoice.saleitem_set[i]
            summarySaved = summarySaved + ((parseFloat(si.mrp) - parseFloat(si.selling_rate)) * parseFloat(si.quantity))
            summaryRate = summaryRate + (parseFloat(si.quantity)* parseFloat(si.selling_rate))
            summaryQuantity = summaryQuantity + parseFloat(si.quantity)
            summaryDiscount = summaryDiscount + parseFloat(si.discount_value)
            summaryTaxable = summaryTaxable + parseFloat(si.price)
            summaryIGST = summaryIGST + parseFloat(si.igst_amount)
            summaryCGST = summaryCGST + parseFloat(si.cgst_amount)
            summarySGST = summarySGST + parseFloat(si.sgst_amount)
            summaryTotal = summaryTotal + parseFloat(si.total)
            const unique_cgst_pct = si.gst.cgst, unique_sgst_pct = si.gst.sgst, unique_igst_pct = si.gst.igst
            const igst_s_amount = parseFloat(si.igst_amount)
            const cgst_s_amount = parseFloat(si.cgst_amount)
            const sgst_s_amount = parseFloat(si.sgst_amount)
            const taxable_price = parseFloat(si.price)
            const total = parseFloat(si.total)

            let cgst_percentages = percentages['cgst']

            if(typeof cgst_percentages[unique_cgst_pct] !== "undefined") {
              let s = cgst_percentages[unique_cgst_pct]

              s.cgst_amount= s.cgst_amount + cgst_s_amount
              s.sgst_amount= s.sgst_amount + sgst_s_amount
              // s.igst_amount= s.igst_amount + igst_s_amount
              s.taxable_price = s.taxable_price + taxable_price
              s.total = s.total + total

            }
            else {
              cgst_percentages[unique_cgst_pct] = {cgst_amount:cgst_s_amount,  sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
              //percentages[unique_pct] = {igst_amount:igst_s_amount, cgst_amount:cgst_s_amount, sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
            }
            percentages['cgst'] = cgst_percentages

            let igst_percentages = percentages['igst']

            if(typeof igst_percentages[unique_igst_pct] !== "undefined") {
              let s = igst_percentages[unique_igst_pct]
              s.igst_amount= s.igst_amount + igst_s_amount
              s.taxable_price = s.taxable_price + taxable_price
              s.total = s.total + total
            }
            else {
              igst_percentages[unique_igst_pct] = {igst_amount:igst_s_amount, taxable_price: taxable_price, total: total}
              //percentages[unique_pct] = {igst_amount:igst_s_amount, cgst_amount:cgst_s_amount, sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
            }

            percentages['igst'] = igst_percentages
          }

          summaryRate = parseFloat(summaryRate).toFixed(2)
          summaryDiscount = parseFloat(summaryDiscount).toFixed(2)
          summaryTaxable = parseFloat(summaryTaxable).toFixed(2)
          summaryIGST = parseFloat(summaryIGST).toFixed(2)
          summaryCGST = parseFloat(summaryCGST).toFixed(2)
          summarySGST = parseFloat(summarySGST).toFixed(2)
          summaryTotal = parseFloat(summaryTotal).toFixed(2)

          let cgst_td_cells=[],  sgst_td_cells=[], igst_td_cells=[]
          let taxRowHeaderBase, taxRowHeader,taxSummary, taxTableRows=[], grossRows = []

          if(typeof settings !== "undefined" && settings !== null) {

            if(settings.show_invoice_tax_analysis) {

              if(invoice.is_igst) {

              }
              else {

                taxRowHeader = <tr key={"tax_row_header"} className="text-right ">
                      <td className="text-right ">Description</td><td className="text-right ">Taxable</td>
                      <td className="text-right ">CGST</td><td className="text-right ">SGST</td></tr>
                taxTableRows.push(taxRowHeader)

                const cgstPercentages = percentages['cgst']
                  let cgst_tax_total = 0.0, sgst_tax_total=0.0, tax_total=0.0
                let percentageKeys  = Object.keys(cgstPercentages)

                if(percentageKeys.length > 0 ) {
                  percentageKeys.sort((a,b)=>{
                       return a - b
                     })
                     for (var i=0; i<percentageKeys.length; i++) {
                       const pct_key = percentageKeys[i]
                       const s = cgstPercentages[pct_key]
                       cgst_tax_total = cgst_tax_total + parseFloat(s.cgst_amount)
                       sgst_tax_total = sgst_tax_total + parseFloat(s.sgst_amount)
                       tax_total = cgst_tax_total+sgst_tax_total
                       const cgst_amount = parseFloat(s.cgst_amount).toFixed(2)
                       const sgst_amount = parseFloat(s.sgst_amount).toFixed(2)

                       const taxable_price = parseFloat(s.taxable_price).toFixed(2)

                       const total = parseFloat(s.cgst_amount + s.sgst_amount).toFixed(2)
                       const taxRow = <tr className="text-right" key={"tax_row_"+i}>
                       <td>GST {Number(pct_key) +Number(pct_key) }%</td>
                       <td>{taxable_price}</td>
                       <td>{cgst_amount}</td>
                       <td>{sgst_amount}</td>

                       </tr>
                       taxTableRows.push(taxRow)
                     }
                }

                cgst_tax_total = parseFloat(cgst_tax_total).toFixed(2)
                sgst_tax_total = parseFloat(sgst_tax_total).toFixed(2)
                tax_total = parseFloat(tax_total).toFixed(2)

                taxSummary = <tr key={"tax_footer_row"} className="text-right">
                  <td >Tax Summary</td>
                  <td>{summaryTaxable}</td>

                  <td>{cgst_tax_total}</td>

                  <td>{sgst_tax_total}</td>

                </tr>

              }

              taxTableRows.push(taxSummary)

            }

          }


          let roundOffValue= parseFloat(invoice.total) - parseFloat(summaryTotal)

          if(roundOffValue >= 0) {
              roundOffValue = "+" + parseFloat(roundOffValue).toFixed(2)
          }
          else {
              roundOffValue = parseFloat(roundOffValue).toFixed(2)
          }

        let additional_params = invoice.additional_params
        let camp_value
        if(typeof additional_params !== "undefined" && additional_params !== null) {
          let camp = additional_params.find(param=>param.key.toLowerCase()=="camp")
          if(typeof camp !== "undefined" && camp !== null) {
            camp_value = <div className="space-small">
                          Camp: <strong>{camp.value}</strong>
                        </div>
          }
        }

        summaryRow =<div className="text-right pull-right">
                    <ul className="list-inline">
                    <li><table className="">
                    <tbody>
                      <tr><td style={{paddingRight:10}}>Total Quantity:</td><td style={{paddingRight:20}}>{summaryQuantity}</td></tr>
                      </tbody>

                    </table></li>
                    <li style={{paddingRight:0}}><table className="">
                      <tbody>
                      <tr><td style={{paddingRight:20}}>RoundOff:</td><td>{roundOffValue}</td></tr>
                      <tr><td style={{paddingRight:20,fontSize:20}}>Net Amount:</td><td style={{fontSize:26}}><strong>{invoice.total }</strong></td></tr>
                      <tr><td colSpan={2} style={{fontSize:26}}>
                      YOU HAVE SAVED: {parseFloat(summarySaved).toFixed(2)}
                      </td></tr>
                      </tbody>
                    </table></li>
                    </ul>
        </div>



        let header_1 =<div className="row">
                <div className="col-sm-6">
                   <div>Invoice No: {serial}</div>
                   <div>Date: {invoice_date}</div>
                </div>
                <div className="col-sm-6 text-right">
                  <div>{company_gstin}</div>
                  <div>{company_phone}</div>
                </div>
        </div>

        let header_2 = <div className="row">
              <div className="col-xs-12 text-center">
                {company_name}
              </div>
        </div>

        let supply_info_1 = <div className="row"><div className="col-xs-12">
          <div className="space-small">
          Place Of Supply: <strong>{place_of_supply}</strong>
          </div>
          {camp_value}
        </div></div>




      let footer = <div className="row">
            <div className="col-xs-12">
              {tnc}
              {declartion}
            </div>

      </div>

      let totalDiscount
      // if(invoice.totalDiscount >0) {
      //   totalDiscount =<tr className="text-right"><td colSpan={table_cols-1 }>Discount</td><td>{invoice.totalDiscount}</td></tr>
      //   summaryRowSpan++
      // }


    return  <div style={{position:'relative'}}>
    <div className="hidden-print" style={{position:'absolute', left:0}}>
      {historySelection}
    </div>
    <div className="preview-a4">
      <TableCustomPadding />
                <table className="table ">
                <tbody>

                    <tr>
                    <td colSpan={table_cols}>
                    {header_2}
                    <div className="text-center">
                    {company_address}
                    </div>
                    {header_1}


                    </td>
                    </tr>

                    <tr className="active">
                    <th className="table-item">Name</th>
                      <th className="table-item text-right">MRP</th>
                      <th className="text-right">Rate</th>
                      <th className="text-right">Qty</th>
                      <th className="text-right">Amount</th>
                    </tr>
                    {items}

                    <tr>

                      <td colSpan={table_cols}>
                      <div className="row">
                        <div className="col-sm-6 hidden-xs">
                        <table className="fullwidth">
                        <tbody>
                        {taxTableRows}
                        </tbody>
                        </table>
                        </div>
                        <div className="col-sm-6">
                          {summaryRow}
                        </div>

                        <div className="col-xs-12 visible-xs-block">
                        <table className="fullwidth">
                        <tbody>
                        {taxTableRows}
                        </tbody>
                        </table>
                        </div>

                      </div>

                      </td>
                    </tr>

                    <tr>
                      <td colSpan={table_cols}>
                        {footer}
                      </td>
                    </tr>

                    </tbody>
                </table>

    </div>
  </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/previews/previewretail.js